export class NgxResponsiveTableConfig {
  allowDensityChange? = false;
  defaultDensity? = 'loose';
  small? = {
    maxCollapsedColumnCount: 3,
  };
  medium? = {
    isFreezeFirstColumn: false,
  };
}
